import { call, put, takeLatest } from 'redux-saga/effects';

import type { GameMetaItem } from '../api/gamesMetaApi';
import { gamesMetaApi } from '../api/gamesMetaApi';
import { gameMetaActions } from './gameMetaSlice';

function* fetchGameMetaSaga(): Generator {
  try {
    const items = (yield call(gamesMetaApi.getGamesMeta)) as GameMetaItem[];
    yield put(gameMetaActions.fetchSuccess(items));
  } catch {
    // silently ignore — cards render without shortDesc
  }
}

export function* gameMetaWatcher(): Generator {
  yield takeLatest(gameMetaActions.fetchRequest.type, fetchGameMetaSaga);
}
